"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "syncedBrandingSettings", {
  enumerable: true,
  get: function get() {
    return _syncedBrandingSettings["default"];
  }
});
var _syncedBrandingSettings = _interopRequireDefault(require("./syncedBrandingSettings"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }